import { NxButtonModule } from '@allianz/ng-aquila/button';
import { NxCopytextModule } from '@allianz/ng-aquila/copytext';
import { NxLinkModule } from '@allianz/ng-aquila/link';
import { NxModalModule } from '@allianz/ng-aquila/modal';

import { NxIconModule } from '@allianz/ng-aquila/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxGridModule } from '@allianz/ng-aquila/grid';
import { NxCheckboxModule } from '@allianz/ng-aquila/checkbox';
import { TextServiceModule } from '@ps20-frontend/text-service';
import { ModalComponent } from './modal.component';

@NgModule({
  imports: [
    NxButtonModule,
    TextServiceModule,
    NxCopytextModule,
    NxIconModule,
    NxLinkModule,
    NxModalModule,
    NxGridModule,
    CommonModule,
    NxCheckboxModule,
    ModalComponent,
  ],
  exports: [ModalComponent],
})
export class ModalModule {}
